import {
  Component,
  Input,
  TemplateRef,
  ViewChild,
  ElementRef,
  OnInit,
  forwardRef,
  EventEmitter,
  Output
} from '@angular/core';
import { ToolBarToolComponent } from '@progress/kendo-angular-toolbar';
import { DatePickerComponent, DateRangeComponent } from '@progress/kendo-angular-dateinputs';

export function outerWidth(element: any): number {
  let width = element.offsetWidth;
  const style = getComputedStyle(element);

  width += parseFloat(style.marginLeft) || 0 + parseFloat(style.marginRight) || 0;
  return width;
}

@Component({
  providers: [{ provide: ToolBarToolComponent, useExisting: forwardRef(() => ToolbarDatePickerComponent) }],
  selector: 'app-toolbar-date-picker',
  templateUrl: './toolbar-date-picker.component.html'
})
export class ToolbarDatePickerComponent extends ToolBarToolComponent {

  @Output() valueChange = new EventEmitter();

  @ViewChild('toolbarTemplate', { static: true }) public toolbarTemplate: TemplateRef<any>;
  @ViewChild('toolbarElement', { static: false }) public toolbarElement: ElementRef;

  @ViewChild('dateRange', { read: DateRangeComponent, static: false }) public dateRange: DateRangeComponent;
  @ViewChild('button', { static: false }) public button: ElementRef;

  public tabindex = -1;
  public range = { start: null, end: null };

  public toggleText = 'Show';
  public show = false;

  constructor() {
      super();
  }

  valueChanged(value: any) {
    this.valueChange.emit(value);
  }

  public get outerWidth(): number {
      if (this.toolbarElement) {
          return outerWidth(this.toolbarElement.nativeElement);
      }
  }

  public canFocus(): boolean {
      return true; // marks the tools as focusable
  }

  public focus(): void {
      // manage the roving tabindex
      // see https://www.w3.org/TR/wai-aria-practices/#kbd_roving_tabindex
      this.tabindex = 0;
      if (this.overflows) {
          // focus the button in the overflowTemplate
          this.button.nativeElement.focus();
      }
  }

  public handleKey(): boolean {
      // manage the roving tabindex
      // see https://www.w3.org/TR/wai-aria-practices/#kbd_roving_tabindex
      this.tabindex = -1;
      // tell the toolbar that the focus can move to the next/prev focusable tool
      return false;
  }
}
